export default "__VITE_ASSET__G67qYc9IpZda8Klm2euzdA__"